import { render, staticRenderFns } from "./BatchInvoiceShippingForm.vue?vue&type=template&id=cbfe9c0c&scoped=true&"
import script from "./BatchInvoiceShippingForm.vue?vue&type=script&lang=ts&"
export * from "./BatchInvoiceShippingForm.vue?vue&type=script&lang=ts&"
import style0 from "./BatchInvoiceShippingForm.vue?vue&type=style&index=0&id=cbfe9c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfe9c0c",
  null
  
)

export default component.exports